<template>
	<div><span class="biaoti">短信接口</span>
		<el-card class="box-card" body-style="padding:0;" style="margin-top: 24px;">
			<el-form label-width="80px" >
				<el-form-item label="设置是否开启短信验证" class="touu" label-width="180px"></el-form-item>
				<el-form-item label="注册短信验证" label-width="180px">
					<el-radio v-model="radio" label="1" style="margin-left: 12px;">开启</el-radio>
					<el-radio v-model="radio" label="2">关闭</el-radio>
					<el-form-item class="tishi" style="margin-left: 8px;">是否开启注册页的短信验证</el-form-item>
				</el-form-item>

			</el-form>
		</el-card>
		<el-card class="box-card" body-style="padding:0;" style="margin-top: 24px;">
			<el-form label-width="80px" >
				<el-form-item label="阿里大鱼( 申请)" class="touu" label-width="140px"></el-form-item>
				<el-form-item label="App key" label-width="200px">
					<el-input v-model="input" placeholder="请输入AppId"></el-input>
				</el-form-item>
				<el-form-item label="App Secret" label-width="200px">
					<el-input v-model="input1" placeholder="请输入AppId"></el-input>
				</el-form-item>
				<el-form-item label="发送模板" label-width="200px">
					<el-input  v-model="input2" size="small" style="width:40%">
						<template slot="prepend">签名</template>
					</el-input>
					<el-input  v-model="input3" size="small" style="width:40%">
						<template slot="prepend">模板ID</template>
					</el-input>
					<el-form-item class="tishi" style="margin-left: 8px;">模板内容: 验证码${code}，您正在登录${product}，若非本人操作，请勿泄露。</el-form-item>
					<!-- 2 -->
					<el-input  v-model="input4" size="small" style="width:40%">
						<template slot="prepend">签名</template>
					</el-input>
					<el-input  v-model="input5" size="small" style="width:40%">
						<template slot="prepend">模板ID</template>
					</el-input>
					<el-form-item class="tishi" style="margin-left: 8px;">模板内容: 验证码${code}，您正在登录${product}，若非本人操作，请勿泄露。</el-form-item>
					<!-- 3 -->
					<el-input placeholder="修改密码" v-model="input6" size="small" style="width:40%">
						<template slot="prepend">签名</template>
					</el-input>
					<el-input placeholder="模板ID如 ：SMS_16361531" v-model="input7" size="small" style="width:40%">
						<template slot="prepend">模板ID</template>
					</el-input>
					<el-form-item class="tishi" style="margin-left: 8px;">模板内容: 验证码${code}，您正在登录${product}，若非本人操作，请勿泄露。</el-form-item>
					<!-- 4 -->
					<el-input placeholder="身份验证" v-model="input8" size="small" style="width:40%">
						<template slot="prepend">签名</template>
					</el-input>
					<el-input placeholder="模板ID如 ：SMS_16361531" v-model="input9" size="small" style="width:40%">
						<template slot="prepend">模板ID</template>
					</el-input>
					<el-form-item class="tishi" style="margin-left: 8px;">模板内容: 验证码${code}，您正在登录${product}，若非本人操作，请勿泄露。</el-form-item>
					<!-- 5 -->
					<el-input placeholder="活动验证" v-model="input10" size="small" style="width:40%">
						<template slot="prepend">签名</template>
					</el-input>
					<el-input placeholder="模板ID如 ：SMS_16361531" v-model="input11" size="small" style="width:40%">
						<template slot="prepend">模板ID</template>
					</el-input>
					<el-form-item class="tishi" style="margin-left: 8px;">模板内容: 验证码${code}，您正在登录${product}，若非本人操作，请勿泄露。</el-form-item>
					
				</el-form-item>
				<el-button type="danger" size="small" style="margin:24px">提交</el-button>
			</el-form>
		</el-card>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				lie: [{
						anniu: '签名',
						anniu2: '模板ID',
						tishi: '修改密码',
						tishi2: '模板ID如 ：SMS_16361531'
					},
					{
						anniu: '签名',
						anniu2: '模板ID',
						tishi: '身份验证',
						tishi2: '模板ID如 ：SMS_16361531'
					},
					{
						anniu: '签名',
						anniu2: '模板ID',
						tishi: '活动验证',
						tishi2: '模板ID如 ：SMS_16361531'
					}
				],

				textarea: '',
				input: '',
				input1: '',
				input2: '',
				input3: '',
				input4: '',
				input5: '',
				input6: '',
				input7: '',
				input8: '',
				input9: '',
				input10: '',
				input11: '',
				radio: "1"
			};
		},

		methods: {

		}
	}
</script>

<style>
	.biaoti {
		display: block;
		width: 100%;
		text-indent: 10px;
		margin-bottom: 16px;
		font-size: 20px;
		color: #788188;
	}

	.touu {
		background: #f7fafa;
		/* text-indent: 5px; */
	}

	.tishi {
		color: #737373;
	}
</style>
